<div class="w-full px-3 py-5  bg-light_primary rounded-md">
  <form [formGroup]="form"
        class="mx-auto w-11/12 grid md:grid-cols-5 grid-cols-1 gap-4  items-center ">
    <div class="flex flex-col gap-1 col-span-1 ">
      <div class="text-md text-primary-500">{{ "Chagua kwa sekta"| concat|translate }}</div>
      <div class="bg-white h-[50px] rounded-lg">
        <mat-form-field formControlName="sectorUniqueId" class=" w-full relative" appearance="outline">
          <mat-select (selectionChange)="selectionChange($event,'sectorUniqueId')"
                      placeholder='{{"Chagua"|concat|translate}}'>
            <mat-option>----</mat-option>
            <mat-option *ngFor="let sector of citizenSectors$|async" [value]="sector?.sectorUniqueId" class="option">
                                              <span class="flex justify-center">
                                                  {{ sector.sectorName }}
                                              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-col gap-1 col-span-1">
      <div class="text-md text-primary-500">{{ "Chagua kwa aina ya huduma"| concat|translate }}</div>
      <div class="bg-white h-[50px] rounded-lg">
        <mat-form-field formControlName="categoryUniqueId" class=" w-full relative" appearance="outline">
          <mat-select (selectionChange)="selectionChange($event,'categoryUniqueId')"
                      placeholder='{{"Chagua"|concat|translate}}'>
            <mat-option>----</mat-option>
            <mat-option *ngFor="let category of servicesCategory$|async" [value]="category?.categoryUniqueId"
                        class="option">
                                              <span class="flex justify-center">
                                                  {{ category.categoryName }}
                                              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-col gap-1 col-span-1">
      <div class="text-md text-primary-500">{{ "Chagua kwa kundi"|concat|translate }}</div>
      <div class="bg-white h-[50px] rounded-lg">
        <mat-form-field formControlName="consumerGroup" class=" w-full" appearance="outline">
          <mat-select (selectionChange)="selectionChange($event,'consumerGroup')" [multiple]="true"
                      placeholder='{{"Chagua"|concat|translate}}'>
            <mat-option *ngFor="let cluster of ServiceClusterEnumOptions" [value]="cluster.name" class="option">
                                              <span class="flex justify-center">
                                                  {{ cluster.value |concat|translate }}
                                              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-col gap-1 col-span-1 ">
      <div class="text-md text-primary-500">{{ "Makundi ya kijamii"|concat|translate }}</div>
      <div class="bg-white h-[50px] rounded-lg">
        <mat-form-field formControlName="socialGroup" class=" w-full" appearance="outline">
          <mat-select (selectionChange)="selectionChange($event,'socialGroup')" [multiple]="true"
                      placeholder='{{"Chagua"|concat|translate}}'>
            <mat-option *ngFor="let needs of specialNeedsOptions" [value]="needs?.value" class="option">
                                              <span class="flex justify-center">
                                                  {{ needs?.name|concat|translate }}
                                              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-col gap-1 col-span-1 ">
      <div class="text-md text-primary-500">{{ "Chagua Mkoa"|concat|translate }}</div>
      <div class="bg-white h-[50px] rounded-lg">
        <mat-form-field formControlName="regionUniqueId" class=" w-full" appearance="outline">
          <mat-select (selectionChange)="selectionChange($event,'regionUniqueId')"
                      placeholder='{{"Chagua"|concat|translate}}'>
            <mat-option>----</mat-option>
            <mat-option *ngFor="let region of regions$ | async" [value]="region?.regionalUniqueId" class="option">
                                              <span class="flex justify-center">
                                                  {{ region?.reginalName }}
                                              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

  </form>
</div>

